module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-products-skin-care-cream.900274b0.png";